import { navigate } from '@reach/router';

export const goUpOne = () => {
  const currentPath = window.location.pathname;
  const upOne = currentPath.slice(0, currentPath.lastIndexOf('/'));
  navigate(upOne);
};
